import React from 'react';
import { getBrandById, brandLogoMap } from '../data/brands';

function ProductCard({ product, style }) {
  return (
    <div className="product-card animate-fade-in-up" style={style}>
      <h3 className="product-title heading-font">{product.title}</h3>
      <p className="product-description">{product.description}</p>

      <div className="product-features">
        <h4>Key Features:</h4>
        <ul>
          {product.features.map((feature, idx) => (
            <li key={idx}>
              <span className="feature-check">✓</span>
              {feature}
            </li>
          ))}
        </ul>
      </div>

      {product.brandIds && product.brandIds.length > 0 && (
        <div className="product-brands">
          <h4>Brands:</h4>
          <div className="brand-logos">
            {product.brandIds.map((brandId, idx) => {
              const brand = getBrandById(brandId);
              if (!brand) return null;
              const displayName = brand.shortName || brand.name;
              return (
                <div key={idx} className="brand-logo-tag" title={displayName}>
                  {brandLogoMap[brandId] ? (
                    <img
                      src={brandLogoMap[brandId]}
                      alt={`${displayName} logo`}
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'inline';
                      }}
                    />
                  ) : null}
                  <span
                    className="brand-logo-text"
                    style={brandLogoMap[brandId] ? { display: 'none' } : {}}
                  >
                    {displayName}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="product-applications">
        <h4>Applications:</h4>
        <div className="application-tags">
          {product.applications.map((app, idx) => (
            <span key={idx} className="app-tag">{app}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
